module.exports = __webpack_public_path__ + "static/media/lead-bg.923e4600.jpg";